import { render, staticRenderFns } from "./errorExercise.vue?vue&type=template&id=3ca1434c&scoped=true"
import script from "./errorExercise.vue?vue&type=script&lang=js"
export * from "./errorExercise.vue?vue&type=script&lang=js"
import style0 from "./errorExercise.vue?vue&type=style&index=0&id=3ca1434c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca1434c",
  null
  
)

export default component.exports